import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
// Libs
import { useEffect, useContext } from 'react'
import { NextPage } from 'next'
import styled from 'styled-components'

// Comps

import { Page } from '../components/Page'
import { Section } from '../components/Section'
import EventItemList from '../components/Discover/EventItemList'
import { UserContext } from '../context'
import { icons, show } from '../utils'
import { P } from '../components/P'
import { CreateEventCTABanner } from '../components/CreateEventCTABanner'
import { useAnalyticsEvent } from '../hooks/analyticsEvent'
import {
  descoverPageStyles,
  Div,
} from '../components/pageStyles/descoverPageStyles'
import { BowedHeroShortSection } from '../components/Sections/BowedHeroShortSection'
import { useSearchableEventList } from '../hooks/useSearchableEventList'

// Styles
const PageContainer = styled(Page)`
  ${descoverPageStyles}
  .sectionContainer {
    width: 100%;
  }
`

// Discover Page.
const DiscoverPage: NextPage = () => {
  const { t } = useTranslation('common')

  // Global State
  const { currentUser } = useContext(UserContext)
  const analyticsEvent = useAnalyticsEvent()

  const { events, hasNextPage, getFirstPage, getNextPage } =
    useSearchableEventList({
      category: 'allCategory',
      search: '',
      paid_type: 'Reset/all',
      sticky: true,
    })
  const eventsToShow = events

  // On Mount get first page
  useEffect(() => {
    getFirstPage()
    analyticsEvent.discoverDiscoverHomepage()
  }, [])

  // ..
  return (
    <PageContainer>
      <BowedHeroShortSection
        bgImage={'/images/discoverHero.svg'}
        largeHeader={t(`Featured Events`, `Featured Events`)}
        smallHeader={t(
          `featured_20220310172127401610787`,
          `Explore upcoming events from Klyk's featured creator community`,
        )}
      />
      {/* Show List for logged in users */}
      {show(currentUser !== null) && (
        <>
          <EventItemList
            eventsToShow={eventsToShow}
            firstEventIndex={0}
            page="Discover"
            showPlaceHolderWhenEmpty={true}
            placeholder={t(`No events found`, `No events found`)}
            numberOfMobileColumns={2}
          />
        </>
      )}

      {/* Show Split list for users that are not logged in */}
      {show(currentUser === null) && (
        <>
          <Div>
            <EventItemList
              eventsToShow={eventsToShow}
              firstEventIndex={0}
              numberOfEventToShow={8}
              page="Discover"
              showPlaceHolderWhenEmpty={true}
              placeholder={t(`No events found`, `No events found`)}
              numberOfMobileColumns={2}
            />

            <Section className="ctaBanner">
              <CreateEventCTABanner
                bannerHeader={t(
                  `featured1189263620`,
                  `Join today for free to start hosting your own events as an individual, or business.`,
                )}
                bannerContent={t(
                  `featured-1592615292`,
                  `A place to organise, plan and host events with your friends, family and broader network.`,
                )}
                showCreateEventButton={true}
              />
            </Section>
            {eventsToShow.length > 8 && (
              <EventItemList
                eventsToShow={eventsToShow}
                firstEventIndex={8}
                page="Discover"
                numberOfMobileColumns={2}
              />
            )}
          </Div>
        </>
      )}
      <Section className="loadMore">
        {hasNextPage === true && (
          <Div
            onMouseDown={(e) => {
              e.preventDefault()
              getNextPage()
              // fetchNextPage()
            }}>
            <P className="callout">{t(`Load more`, `Load more`)}</P>
            <img className="arrowDown" src={icons.arrowDown}></img>
          </Div>
        )}
      </Section>
    </PageContainer>
  )
}

// Export.
export default DiscoverPage
export async function getStaticProps({ locale }) {
  const translations = await serverSideTranslations(locale, ['common'])
  return {
    props: {
      ...translations,
    },
  }
}
